import React from 'react'
import * as ReactModal  from 'react-modal'
import Icons from '../Components/Icons'
import css from './Modal.module.scss'


export default function Modal({isOpen, closeModal, style = {}, children}) {
	return (
		<ReactModal
			isOpen={isOpen}
			onRequestClose={closeModal}
			ariaHideApp={false}
			style={{
				overlay: {
					position: 'fixed',
					top: 0,
					left: 0,
					right: 0,
					bottom: 0,
					backgroundColor:'rgba(0, 0, 0, 0.6)',
					textAlign: 'center',
					zIndex:9999,
					overflow: 'auto',
					padding:'50px 0'
				}, content: {
					position:'static',
					display: 'inline-block',
					background: '#fff',
					overflow: 'auto',
					border: 'none',
					WebkitOverflowScrolling: 'touch',
					outline: 'none',
					boxShadow: '5px 15px 25px rgba(0, 0, 0, 0.5)',
					borderRadius: 'none',
					padding: '0',
					width:'900px',
					maxWidth: '100%',
					margin: '0 auto'
				},
				...style
			}}
		>
			<div className={css.modal}>
				<div className={css.close} onClick={closeModal}>
					<Icons name="close"/>
				</div>
				{children}
			</div>
		</ReactModal>
	)
}